import { call, put, select } from 'redux-saga/effects';
import { photoCaptureUploadDamageAttachmentsSaga } from './photoCaptureUploadDamageAttachmentsSaga';
import { photoCaptureIntelligentDamageDetectionFailureAction, photoCaptureIntelligentPostPrtcDetailsRequestAction, photoCaptureIntelligentUpdateIterationDamageCallStatusAction } from '../actions';
import { IntelligentPhotoCaptureAttachmentIterationStatus } from '../enums';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
import { getAttachmentIterationInfo, getPhotoCapturePrtcDetailsData } from '../selectors';
export function* intelligentDamageDetectionSuccessSaga(action) {
    var _a, _b, _c;
    try {
        const { iterationId } = action.payload;
        const responseRequestId = (_a = action.payload.damageDetectionResponse) === null || _a === void 0 ? void 0 : _a.requestId;
        let resolvedIterationId = typeof iterationId === 'number' && Number.isFinite(iterationId) ? iterationId : undefined;
        if (resolvedIterationId === undefined && responseRequestId) {
            const requestIdParts = responseRequestId.split('_');
            const parsedIterationId = parseInt(requestIdParts[requestIdParts.length - 1], 10);
            resolvedIterationId = Number.isFinite(parsedIterationId) ? parsedIterationId : undefined;
        }
        const attachmentIterationInfo = yield select(getAttachmentIterationInfo);
        const hasResolvedIterationInState = typeof resolvedIterationId === 'number' &&
            attachmentIterationInfo.some((iteration) => iteration.iterationId === resolvedIterationId);
        if (!hasResolvedIterationInState) {
            const inProgressIteration = attachmentIterationInfo.find((iteration) => iteration.damageCallStatus === IntelligentPhotoCaptureAttachmentIterationStatus.IN_PROGRESS);
            const pendingCompletedIteration = attachmentIterationInfo.find((iteration) => iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED &&
                iteration.batchIds.length > 0 &&
                iteration.damageCallStatus === IntelligentPhotoCaptureAttachmentIterationStatus.PENDING);
            const fallbackIterationId = (_b = inProgressIteration === null || inProgressIteration === void 0 ? void 0 : inProgressIteration.iterationId) !== null && _b !== void 0 ? _b : pendingCompletedIteration === null || pendingCompletedIteration === void 0 ? void 0 : pendingCompletedIteration.iterationId;
            if (typeof fallbackIterationId === 'number' && Number.isFinite(fallbackIterationId)) {
                resolvedIterationId = fallbackIterationId;
            }
        }
        // Mark the damage call as completed for this iteration so the serialization
        // gate in usePhotoCaptureEstimatorWorker can unblock the next pending iteration.
        if (resolvedIterationId !== undefined) {
            yield put(photoCaptureIntelligentUpdateIterationDamageCallStatusAction(resolvedIterationId, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED));
        }
        const prtcs = (action.payload.damageDetectionResponse.recommendations || [])
            .map(recommendation => recommendation.partCode)
            .filter((partCode) => Boolean(partCode));
        const prtcDetailsData = yield select(getPhotoCapturePrtcDetailsData);
        const existingPrtcCodes = new Set(((_c = prtcDetailsData === null || prtcDetailsData === void 0 ? void 0 : prtcDetailsData.prtcs) === null || _c === void 0 ? void 0 : _c.map(item => item.prtc)) || []);
        const seenCodes = new Set(existingPrtcCodes);
        const newPrtcs = prtcs.reduce((acc, code) => {
            if (!seenCodes.has(code)) {
                seenCodes.add(code);
                acc.push(code);
            }
            return acc;
        }, []);
        if (newPrtcs.length > 0) {
            yield put(photoCaptureIntelligentPostPrtcDetailsRequestAction({ prtcs: newPrtcs }));
        }
        else {
            yield call(photoCaptureUploadDamageAttachmentsSaga);
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentDamageDetectionFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentDamageDetectionSuccessSaga.js.map